// import React from 'react';
// import Box, { BoxProps } from '@mui/material/Box';
// import styled from 'styled-components';
// import boxStyles from './box.styles';

// interface ApBoxProps extends BoxProps {
// 	ap_type?: 'flex' | 'span';
// 	ap_display?: 'none';
// }
// const apAtomName = { ap_atom_name: 'boxAtom' };

// const BoxAtom = styled((props: ApBoxProps) => {
// 	return <Box {...apAtomName} {...props} />;
// })`
//   ${boxStyles}
// `;

// export default BoxAtom;

import React from 'react'
import {StyledComponentProps} from '@mui/material'
import Box, {BoxProps} from '@mui/material/Box'

interface ApBoxProps extends BoxProps, StyledComponentProps {}

const apAtomName = {ap_atom_name: 'boxAtom'}

const BoxAtom = function ({classes, children, ...props}: ApBoxProps) {
  return (
    <Box {...apAtomName} {...classes} {...props}>
      {children}
    </Box>
  )
}

export default BoxAtom
